import { TabList as MuiTabList } from '@mui/lab'
import { Tab, Tabs as MuiTabs } from '@mui/material'
import { withStyles } from '@mui/styles'

export const tabsStyles = theme => ({
  root: {
    minHeight: 36,
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
})
export const Tabs = withStyles(tabsStyles, { name: 'AroyaTabs' })(MuiTabs)

export const TabList = withStyles(tabsStyles, { name: 'AroyaTabList' })(MuiTabList)

export default withStyles(theme => ({
  root: {
    minHeight: '2rem',
    maxHeight: '2rem',
    padding: `0 ${theme.spacing(3)}`,
    fontSize: '1rem',
    color: theme.palette.primary.main,
    '&.Mui-selected': {
      background: 'transparent',
      borderRadius: 0,
    }
  },
}), { name: 'AroyaTab' })(Tab)
